<template>
  <div class="app flex-row align-items-center" >
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8" lg="6">
          <b-card no-body class="p-4">
            <b-card-body>
              <Language />
              <h3><img src="/ui/img/logo/logo-f1.png" width="45" height="40" alt="user image"> Rule Server <small>로그인</small></h3>
              <b-input-group class="my-3">
                <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                <input type="text" class="form-control" placeholder="ID" v-model="m.username" @keyup.enter="login()">
              </b-input-group>
              <b-input-group class="mb-3">
                <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                <input type="password" class="form-control" placeholder="Password" v-model="m.password" @keyup.enter="login()">
              </b-input-group>
              <b-row>
                <b-col cols="6" class="text-left">
                  <b-checkbox v-model="remember_username">Remember ID</b-checkbox>
                </b-col>
                <b-col cols="6" class="text-right">
                  <b-button variant="primary" class="px-4" @click="login()">Submit</b-button>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import App from './app.js';export default Object.assign({}, App);
</script>
